import { render, staticRenderFns } from "./early-access.vue?vue&type=template&id=1253d7cf&scoped=true&"
import script from "./early-access.vue?vue&type=script&lang=js&"
export * from "./early-access.vue?vue&type=script&lang=js&"
import style0 from "./early-access.vue?vue&type=style&index=0&id=1253d7cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253d7cf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JoinUs: require('/opt/build/repo/components/JoinUs.vue').default,Layout: require('/opt/build/repo/components/Layout.vue').default})
